import React from 'react';
import SubscriptionNavTabs from '../sms/SubscriptionNavTabs/SubscriptionNavTabs';

const BillingLayout = ({ children }) => (
  <>
    <SubscriptionNavTabs activeKey="/s/subscription/billing" />
    {children}
  </>
);
export default BillingLayout;
